import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type FreeTextFilter } from '../types/filters';

export const nameDefinition: FilterDefinition<FreeTextFilter> = {
  id: FilterId.NAME,
  name: 'Name',
  text: [],
  type: FilterType.FREE_TEXT,
  isVisible: true,
};

export const nameHandler: FilterHandler<FreeTextFilter> = {
  isActive(currentFilterState: FreeTextFilter) {
    return currentFilterState.text.length > 0;
  },
  isDefault(
    currentFilterState: FreeTextFilter,
    definition: FilterDefinition<FreeTextFilter>
  ) {
    return currentFilterState.text.length === definition.text.length;
  },
  getEffectiveFilter(currentFilterState: FreeTextFilter) {
    return { ...currentFilterState };
  },
};
